<template>
  <div class="container-fluid">
    <div class="row">
      <input :id="Options.id" @change="upload($event)" type="file" class="d-none" accept="image/png, image/gif, image/jpeg" />
      <div class="col-md-6 col-12">
        <article @click="click">
          <img :key="DefaultSrc" class="imgSize" :src="DefaultSrc == null || DefaultSrc == '' ? defaultAddress : DefaultSrc" alt="" />
        </article>
      </div>
      <div class="col-md-6 col-12 pt-5">
        <div>
          <p>نام فایل:</p>
          <p>حجم فایل:</p>
        </div>
        <div class="row">
          <div class="col-12">
            <button @click.prevent="SubmitIMG" class="btn btn-success w-100">ذخیره تصویر</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['Options'],
  data() {
    return {
      defaultAddress: '/img/icons/OHUploader.png',
      DefaultSrc: null,
    }
  },
  methods: {
    upload() {
      const file = document.getElementById(this.Options.id).files[0]
      if (file) {
        // Set the image source to the data URL representing the image
        this.DefaultSrc = URL.createObjectURL(file)
      }
    },
    click() {
      document.getElementById(this.Options.id).click()
    },
    delete() {},
    SubmitIMG() {
      var DataAxios = { Action: '', ArryfildValue: '', Method: 'POST' }
      console.warn(this.Options)
      if (!this.Options.tblAttachments || this.Options.tblAttachments.Id == 10) {
        DataAxios.Action = 'CrmFile/Add'
        this.Options['tblAttachments']['Filepath'] = this.Options.SaveFolder
      } else {
        DataAxios.Action = 'CrmFile/Edit'
      }
      const formData = new FormData()
      for (const key in this.Options.tblAttachments) {
        formData.append(key, this.Options.tblAttachments[key])
      }
      formData.append('file', document.getElementById(this.Options.id).files[0])
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((result) => {
        console.warn(result)
      })
    },
  },
  created() {
    if (this.Options.tblAttachments) {
      console.warn(this.Options.tblAttachments)
      if (this.Options.tblAttachments.filepath == null || this.Options.tblAttachments.filepath == '') {
        this.DefaultSrc = null
      } else {
        this.DefaultSrc = $cookies.get('URL') + this.Options.tblAttachments.filepath
      }
    }
  },
  mounted() {},
}
</script>
<style scoped>
.imgSize {
  max-height: 20vh;
  max-width: 100% !important;
}
.Rounded {
  border-radius: 2%;
}
</style>
